"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.structure = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/List/List");
const SelectionContext_1 = require("../../../TdWebtoolkitControls/controls/Menu/SelectionContext");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const PropertyPage_1 = require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
require("../../../TdWebtoolkitControls/controls/Tabs/Tabs");
require("../../../TdWebtoolkitControls/controls/Tree/Tree");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const ModificationInfo_1 = require("../../../TdWebtoolkitControls/model/ModificationInfo");
const $ = require("jquery");
const m = require("../SynView");
class structure extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        const that = this;
        super.init(viewName, viewIndex, viewHtml);
        that.icon = "fa-sitemap";
        that.m_tabSelectionChangedOnce = false;
    }
    disableUI(disable = true) {
        const that = this;
        super.disableUI(disable);
        if (disable) {
            that.m_$tabs.find(".k-tabstrip-items > .k-item").attr("disabled", "disabled").addClass("k-state-disabled");
            that.m_$tree.find("li.k-item")
                .addClass("k-state-disabled")
                .addClass("unsavedchanges")
                .on("click.unsavedchanges", function (e) {
                e.preventDefault();
                return false;
            });
            if (that.m_$preview.synPreview("isEditable")) {
                that.m_$tabs.synTabs("lockSynList", true);
                that.m_$preview.find(".k-tabstrip-items > .k-item").attr("disabled", "disabled").addClass("k-state-disabled");
            }
        }
        else {
            that.m_$tabs.find(".k-tabstrip-items > .k-item").removeAttr("disabled").removeClass("k-state-disabled");
            that.m_$tree.find("li.k-item.unsavedchanges")
                .removeClass("k-state-disabled")
                .removeClass("unsavedchanges")
                .off("click.unsavedchanges");
            if (that.m_$preview.synPreview("isEditable")) {
                that.m_$tabs.synTabs("lockSynList", false);
                that.m_$preview.find(".k-tabstrip-items > .k-item").removeAttr("disabled").removeClass("k-state-disabled");
            }
        }
    }
    setURL() {
        const that = this;
        if (!that.IsActiveView)
            return;
        $.address.autoUpdate(false);
        $.address.parameter("path", encodeURIComponent(that.m_path || ""), false);
        $.address.parameter("id", that.m_id, false);
        $.address.parameter("relid", that.m_relId ? that.m_relId.toString() : "", false);
        $.address.update();
        $.address.autoUpdate(true);
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        this.m_path = typeof ($.address.parameter("path")) === "undefined" ? "" : decodeURIComponent($.address.parameter("path"));
        this.m_root = typeof ($.address.parameter("root")) === "undefined" ? "" : decodeURIComponent($.address.parameter("root"));
    }
    getSelectionContext() {
        if (!this.m_$tree.synTree("isInitialized") || !this.m_$tabs.synTabs("isInitialized"))
            return super.getSelectionContext();
        let parentControl = false;
        let normalParentContext = {
            parentRelId: SelectionContext_1.SpecialRelIds.Undefined
        };
        let parentControlParentContext = {
            parentRelId: SelectionContext_1.SpecialRelIds.Undefined
        };
        let selectedIds = [];
        const selectedTreeNodeId = this.m_$tree.synTree("getSelectedId");
        if (typeof selectedTreeNodeId === "undefined")
            return super.getSelectionContext();
        const selectedTreeNodeParentId = this.m_$tree.synTree("getSelectedParentId");
        const selectedTabRelId = this.m_$tabs.synTabs("getSelectedRelId");
        const selectedTabIds = this.m_$tabs.synTabs("getSelectedIds");
        if (this.m_$tree.synTree("isFocused")) {
            // Tree node is focused
            parentControl = true;
            selectedIds = [selectedTreeNodeId];
            parentControlParentContext.parentId = selectedTreeNodeId;
            parentControlParentContext.parentRelId = SelectionContext_1.SpecialRelIds.All;
            if (!this.m_$tree.synTree("isRootNodeSelected")) {
                normalParentContext.parentId = selectedTreeNodeParentId;
                normalParentContext.parentRelId = SelectionContext_1.SpecialRelIds.All;
            }
        }
        else {
            // Tab control is focused
            if (this.m_$tabs.synTabs("currentTabIsPropertyTab")) {
                parentControl = true;
                parentControlParentContext.parentId = selectedTreeNodeId;
                parentControlParentContext.parentRelId = SelectionContext_1.SpecialRelIds.All;
                if (!this.m_$tree.synTree("isRootNodeSelected")) {
                    normalParentContext.parentId = selectedTreeNodeParentId;
                    normalParentContext.parentRelId = SelectionContext_1.SpecialRelIds.All;
                }
                selectedIds = [selectedTreeNodeId];
            }
            else {
                normalParentContext.parentId = selectedTreeNodeId;
                normalParentContext.parentRelId = selectedTabRelId;
                selectedIds = selectedTabIds;
            }
        }
        return {
            parentControl,
            normalParentContext,
            parentControlParentContext,
            selectedIds
        };
    }
    createTreeAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            yield that.m_$tree
                .on("nodeSelected", (_e, selectionData) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                that.m_$tree.synTree("focus", true);
                that.m_$tabs.synTabs("focus", false);
                that.m_path = selectionData.path;
                that.setURL();
                yield that.m_$tabs.synTabs("setParentAsync", selectionData.selectedId, that.m_lastSelectedRelId);
                yield that.m_$preview.synPreview("setInstanceAsync", selectionData.selectedId, !that.m_$tabs.synTabs("hasPropertyTab"));
                that.m_tabSelectionChangedOnce = false;
                that.updateSelectionContext();
            }))
                .on("nodeRefocusRequested", () => {
                that.m_$tree.synTree("focus", true);
                that.m_$tabs.synTabs("focus", false);
                that.m_$preview.synPreview("setInstanceAsync", that.m_$tree.synTree("getSelectedId"), true);
                that.updateSelectionContext();
            })
                .on("focusedNodeClick", () => {
                that.m_$tabs.synTabs("focus", false);
                that.m_$preview.synPreview("setInstanceAsync", that.m_$tree.synTree("getSelectedId"), true);
                that.updateSelectionContext();
            })
                .synTree({
                initialSelection: this.m_path || undefined,
                rootNodeId: that.m_root,
                expandInitiallySelectedNode: "OnlyRootNode"
            });
            const curPath = that.m_$tree.synTree("getPath");
            const curSelectedId = that.m_$tree.synTree("getSelectedId");
            const curSelectedParentId = that.m_$tree.synTree("getSelectedParentId");
            that.updateSelectionContext();
        });
    }
    createTabsAsync(parentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            yield that.m_$tabs
                .on("selectionChanged", (_e, _parentid, _relId, ids) => {
                that.m_$tree.synTree("focus", false);
                that.m_$tabs.synTabs("focus", true);
                if (ids.length === 1)
                    that.m_$preview.synPreview("setInstanceAsync", ids[0], true);
                else
                    that.m_$preview.synPreview("clearView");
                that.updateSelectionContext();
            })
                .on("tabRefocusRequested", () => {
                that.m_$tree.synTree("focus", false);
                that.m_$tabs.synTabs("focus", true);
                const ids = that.m_$tabs.synTabs("getSelectedIds");
                if (ids.length === 1)
                    that.m_$preview.synPreview("setInstanceAsync", ids[0], true);
                else
                    that.m_$preview.synPreview("clearView");
                that.updateSelectionContext();
            })
                .on("listItemsRefocusRequested", () => {
                that.m_$tree.synTree("focus", false);
                that.m_$tabs.synTabs("focus", true);
                const ids = that.m_$tabs.synTabs("getSelectedIds");
                if (ids.length === 1)
                    that.m_$preview.synPreview("setInstanceAsync", ids[0], true);
                else
                    that.m_$preview.synPreview("clearView");
                that.updateSelectionContext();
            })
                .on("tabSelected", (_e, parentid, relId, isPropertyTab) => {
                that.m_lastSelectedRelId = relId;
                that.m_$tree.synTree("focus", false);
                that.m_$tabs.synTabs("focus", true);
                const tabIndex = that.m_$tabs.synTabs("getSelectedTabIndex");
                if (tabIndex < 1)
                    that.m_relId = undefined;
                else
                    that.m_relId = relId ? relId : that.m_relId;
                if (that.m_tabSelectionChangedOnce)
                    $.address.history(false);
                that.setURL();
                if (that.m_tabSelectionChangedOnce)
                    $.address.history(true);
                that.m_tabSelectionChangedOnce = true;
                const selectedIds = that.m_$tabs.synTabs("getSelectedIds");
                if (selectedIds.length === 1)
                    that.m_$preview.synPreview("setInstanceAsync", selectedIds[0], true);
                else if (isPropertyTab)
                    that.m_$preview.synPreview("setInstanceAsync", parentid, !that.m_$tabs.synTabs("hasPropertyTab"));
                else
                    that.m_$preview.synPreview("clearView");
                that.updateSelectionContext();
            })
                .on("rowDoubleClicked", (_evt, _parentId, _relId, id) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let action = Utilities_1.synUtil.Configs.getValue("webtoolkitlistdblclickaction", undefined, parseInt(id.split("|")[2], 10));
                if (action === "navigate")
                    that.m_$tree.synTree("tryOpenChildNodeAsync", id);
            }))
                .on("propertyPageValuesChanged", () => {
                that.askSaveChanges(false, (saveResult) => {
                    that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("deleteUnsavedChanges");
                    if (saveResult === m.ViewSaveResult.Save && !that.m_saveInProgress) {
                        that.m_saveInProgress = true;
                        Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                        that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("commitChanges", {
                            success(currentInstance, commitResult) {
                                switch (commitResult) {
                                    case PropertyPage_1.CommitSuccess.Saved:
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                        that.m_$preview.synPreview("recreateAsync");
                                        that.CommandTriggerTarget.trigger("forceRefresh", [{
                                                fullRefreshNecessary: false,
                                                modifiedInstances: [currentInstance]
                                            }]);
                                        break;
                                    case PropertyPage_1.CommitSuccess.Created:
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                        break;
                                    case PropertyPage_1.CommitSuccess.NoChanges:
                                        Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                        break;
                                    default:
                                        break;
                                }
                                that.m_saveInProgress = false;
                                that.disableUI(false);
                            },
                            cleanUp() {
                                that.m_saveInProgress = false;
                                Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                            },
                            updatePropertyPageAfterCommit: true
                        });
                    }
                    else if (saveResult === m.ViewSaveResult.Cancel) {
                        that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("refresh");
                        that.disableUI(false);
                    }
                });
            })
                .on("propertyPageValuesReverted", () => {
                that.disableUI(false);
            })
                .on("tabCreated", () => {
                that.resizeControls();
            })
                .css("height", "100%")
                .synTabs({
                propertyPageMode: Base_1.PropertyPageMode.Edit,
                windowName: "treeeditormainframe",
                resizableCols: true,
                sortableCols: true,
                parentContext: {
                    parentId: parentId,
                    parentRelId: that.m_relId || SelectionContext_1.SpecialRelIds.Undefined
                },
                allowDragDrop: true
            });
            that.m_$tabs.synTabs("focus", typeof that.m_relId !== "undefined");
        });
    }
    createPreviewAsync(selectedId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            yield that.m_$preview
                .on("propertyPageValuesChanged", () => {
                that.askSaveChanges(false, (saveResult) => {
                    if (saveResult === m.ViewSaveResult.Save && !that.m_saveInProgress) {
                        that.m_saveInProgress = true;
                        Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                        that.m_$preview.synPreview("getPropertyPage").synPropertyPage("commitChanges", {
                            success(currentInstance, commitResult) {
                                switch (commitResult) {
                                    case PropertyPage_1.CommitSuccess.Saved:
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                        that.m_$preview.synPreview("recreateAsync");
                                        break;
                                    case PropertyPage_1.CommitSuccess.Created:
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                        break;
                                    case PropertyPage_1.CommitSuccess.NoChanges:
                                        Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                        break;
                                    default:
                                        break;
                                }
                                that.m_saveInProgress = false;
                                that.disableUI(false);
                            },
                            cleanUp() {
                                that.m_saveInProgress = false;
                                Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                            },
                            updatePropertyPageAfterCommit: true
                        });
                    }
                    else if (saveResult === m.ViewSaveResult.Cancel) {
                        that.m_$preview.synPreview("getPropertyPage").synPropertyPage("refresh");
                        that.disableUI(false);
                    }
                });
            })
                .on("propertyPageValuesReverted", () => {
                that.disableUI(false);
            })
                .synPreview({
                id: selectedId,
                editable: !that.m_$tabs.synTabs("hasPropertyTab")
            });
        });
    }
    renderContents() {
        const that = this;
        let selectionStore = that.CommandLayouts.SelectionContext.getStoredSelectionContext(that.m_viewName);
        that.emptySelection();
        that.m_$preview = that.m_$container.find("#Preview");
        that.m_$tree = $("#Tree");
        that.m_$tabs = $("#Tabs");
        if (!that.m_externalChangeEventRegistered) {
            that.m_externalChangeEventRegistered = true;
            $.address.externalChange((evt) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (evt.value === "/structure" || evt.value.indexOf("/structure?") === 0) {
                    that.getParametersFromUrl();
                    if (that.m_$tree.synTree("isInitialized")) {
                        const setPathResult = yield that.m_$tree.synTree("trySetPathAsync", that.m_path || "");
                        const selectedTreeNodeId = that.m_$tree.synTree("getSelectedId");
                        yield that.m_$tabs.synTabs("setParentAsync", selectedTreeNodeId, that.m_relId);
                        yield that.m_$preview.synPreview("setInstanceAsync", selectedTreeNodeId, !that.m_$tabs.synTabs("hasPropertyTab"));
                        that.m_$tree.synTree("focus", setPathResult !== "PathUnchanged");
                        that.m_$tabs.synTabs("focus", setPathResult === "PathUnchanged");
                        that.m_tabSelectionChangedOnce = false;
                        that.m_lastSelectedRelId = that.m_relId;
                        that.updateSelectionContext();
                    }
                }
            }));
        }
        that.createTreeAsync().then(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            that.m_$tree.synTree("focus", typeof that.m_relId === "undefined");
            const selectedTreeNode = that.m_$tree.synTree("getSelectedId");
            yield that.createTabsAsync(selectedTreeNode);
            that.m_lastSelectedRelId = that.m_$tabs.synTabs("getSelectedRelId");
            yield that.createPreviewAsync(selectedTreeNode);
            that.updateSelectionContext();
        }));
    }
    forceRefresh(modificationInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            let fullRefresh = false;
            if (!modificationInfo)
                fullRefresh = true;
            else {
                if (modificationInfo.fullRefreshNecessary)
                    fullRefresh = true;
                else {
                    if (modificationInfo.modifiedInstances) {
                        that.m_$tree.synTree("update", modificationInfo.modifiedInstances);
                        that.m_$tabs.synTabs("update", modificationInfo.modifiedInstances);
                        that.m_$preview.synPreview("update", modificationInfo.modifiedInstances);
                    }
                    else if (modificationInfo.deletions) {
                        if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Object) {
                            that.m_$preview.synPreview("delete", modificationInfo.deletions.instances);
                            yield Promise.all([
                                that.m_$tree.synTree("unlinkAsync", modificationInfo.deletions.instances, modificationInfo.deletions.parent),
                                that.m_$tabs.synTabs("delete", modificationInfo.deletions.instances)
                            ]);
                        }
                        else if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Link && modificationInfo.deletions.parent) {
                            that.m_$preview.synPreview("delete", modificationInfo.deletions.instances);
                            yield Promise.all([
                                that.m_$tree.synTree("unlinkAsync", modificationInfo.deletions.instances, modificationInfo.deletions.parent),
                                that.m_$tabs.synTabs("unlinkAsync", modificationInfo.deletions.instances, modificationInfo.deletions.parent, modificationInfo.deletions.relation)
                            ]);
                        }
                    }
                    else if (modificationInfo.new) {
                        yield Promise.all([
                            that.m_$tree.synTree("linkAsync", modificationInfo.new.instances, modificationInfo.new.parent),
                            that.m_$tabs.synTabs("linkAsync", modificationInfo.new.instances, modificationInfo.new.parent, modificationInfo.new.relation)
                        ]);
                    }
                }
            }
            if (fullRefresh) {
                yield Promise.all([
                    that.m_$preview.synPreview("recreateAsync"),
                    that.m_$tree.synTree("refreshAsync", true)
                ]);
                that.m_$tabs.synTabs("refreshCurrentTab");
            }
        });
    }
}
exports.structure = structure;
